export default "__VITE_ASSET__Dacg0rkl__"